import Alpine from "alpinejs";

Alpine.data("horizontalProgressBar", () => ({
    progressBars: '',

    init() {
        let self = this;

        window.addEventListener('message', (event) => {
            if (event.data.type === 'add-hProgressBar') {
                self.progressBars = JSON.parse(event.data.progressBars);
            }
        });
    },

    getMargin(progress) {
        return 'ms-[calc('+progress+'-1.25rem)]'
    },

    updateProgressBars(newProgressBars) {
        this.progressBars = newProgressBars;
    },

    getBgStyles(color, progress, roundedCorners, height) {
        let styles = 'background-color: ' + color + ';';

        if (progress !== null && progress !== undefined) {
            styles += progress + ';';
        }

        if (roundedCorners !== null && roundedCorners !== undefined) {
            styles += ' border-radius:' + roundedCorners + 'px;';
        }

        if (height !== null && height !== undefined) {
            styles +=  ' height:' + height + 'px;';
        }

        return styles;
    },

    getTextStyles(textColor, backgroundColor, borderColor, borderRadius, labelFontSize) {
        let styles = '';

        if (textColor !== null && textColor !== undefined) {
            styles += 'color: ' + textColor + '; ';
        }

        if (backgroundColor !== null && backgroundColor !== undefined) {
            styles += 'background-color: ' + backgroundColor + '; ';
        }

        if (borderColor !== null && borderColor !== undefined && borderColor !== '') {
            styles += 'border: 1px solid ' + borderColor + '; ';
        }

        if (borderRadius !== null && borderRadius !== undefined) {
            styles += 'border-radius: ' + borderRadius + 'px; ';
        }

        if (labelFontSize !== null && labelFontSize !== undefined && labelFontSize !== '') {
            styles += 'font-size: ' + labelFontSize + 'px; ';
        }
        return styles;
    }
}));